import { gql } from "@apollo/client";

export const GET_NPID = gql`
    query NutricionParenteralRIByDatosGeneralesId (
        $idDatosGenerales: Int!
    ) {
        nutricionParenteralRIByDatosGeneralesId (
            idDatosGenerales: $idDatosGenerales
        ){
            nutricionParenteralRI{
                idNutricionParenteralIntradialiticaRI

                idComboRIValorKarnofsky
                idComboRIValorKarnofskyNavigation{
                    valor
                }
                proteinasTotales
                lipidosTotales
                caloriasTotales
                presenciaEdemas
                laboratorio

                idComboRIValorFAV
                idComboRIValorFAVNavigation{
                    valor
                }
                idComboRIValorTipoCateter
                idComboRIValorTipoCateterNavigation{
                    valor
                }
                fechaColocacion
                idComboRIValorUbicacion
                idComboRIValorUbicacionNavigation{
                    valor
                }
                idComboRIValorNroLumenes
                idComboRIValorNroLumenesNavigation{
                    valor
                }
                cateterNormal
                bAPestandar
                magistral
                volumenMagistral
                idComboRIValorMotivoIndicacionMagistral
                idComboRIValorMotivoIndicacionMagistralNavigation{
                    valor
                }
            }
            laboratorioAdjunto{
                contentType
                titulo
                archivo
                extension
            }
            indicacionRI{
                idInsumo
                cantidadDiaria
                idInsumoNavigation{
                    descripcion
                }
            }
            diaConexionEstandar
            diaConexionMagistral
        }
    }
`;